// @flow

import type { UiPopup, UiPopupAction } from '../type/uiPopup'

const initState = { popupType: null }

export default function (state: UiPopup = initState, action: UiPopupAction) {
  if (action.type === 'UI_POPUP') {
    return action
  }
  if (action.type === 'UI_POPUP_CLOSE') {
    return initState
  }
  return state
}



// WEBPACK FOOTER //
// ./src/redux/reducers/uiPopup.js